import { useEffect, useState } from "react";
import { useLocation } from "@reach/router";

export function useEmitations() {
  const [co2, setCo2] = useState(0);

  const { href } = useLocation();

  async function getCo2() {
    const cached = JSON.parse(localStorage.getItem("estimatedCO2") || "{}");

    try {
      if (cached?.value && Number(cached?.validUntill) > Date.now()) {
        return setCo2(Number(cached.value));
      }

      const response = await fetch(
        `https://co2-api.netlify.app/${encodeURIComponent(href)}`,
        { method: "GET" }
      );
      const data: { body: { estimatedCO2: string } } = await response.json();

      localStorage.setItem(
        "estimatedCO2",
        JSON.stringify({
          value: Number(data.body.estimatedCO2).toFixed(2),
          validUntill: Date.now() + 1000 * 60 * 60 * 24 * 3, // caching for 3 days
        })
      );

      setCo2(Number(Number(data.body.estimatedCO2).toFixed(2)));
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log("Problem with fetching Co2 data", { err });
    }
  }

  useEffect(() => {
    getCo2();
  }, []);

  return {
    co2,
  };
}
